import { Directive, Input, OnDestroy, TemplateRef, ViewContainerRef } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { UserService } from 'app/core/user/user.service';
import { User } from 'app/core/user/user.types';
import { Subscription } from 'rxjs';


@Directive({
  selector: '[appHasPermission]'
})
export class HasPermissionDirective implements OnDestroy {
  @Input() set appHasPermission(permission: string) {
    this._userService.user$.subscribe((user: User) => {
              let display = user.permissions.some(x => x == permission); 
              // alert(display)
                if (display) {
                this.viewContainer.createEmbeddedView(this.templateRef);
              } else {
                this.viewContainer.clear();
              }
    })
    
  }

  user: User;
  subscription: Subscription;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private authService: AuthService,
    private _userService: UserService
  ) {
     
  }

  ngOnDestroy() {
  }
}